export enum CheckoutInfoMessageTone {
  NEUTRAL = 'neutral',
  DANGER = 'danger',
  SUCCESS = 'success',
}

export const CHECKOUT_INFO_MESSAGE_ICON: Record<CheckoutInfoMessageTone, string> = {
  [CheckoutInfoMessageTone.NEUTRAL]: 'icon-info',
  [CheckoutInfoMessageTone.DANGER]: 'icon-exclamation-triangle',
  [CheckoutInfoMessageTone.SUCCESS]: 'icon-check',
};

export const CHECKOUT_INFO_MESSAGE_TEXT_CLASS: Record<CheckoutInfoMessageTone, string> = {
  [CheckoutInfoMessageTone.NEUTRAL]: 'content-sub-text',
  [CheckoutInfoMessageTone.DANGER]: 'content-danger',
  [CheckoutInfoMessageTone.SUCCESS]: 'content-success',
};

export interface CheckoutInfoMessageProps {
  message: string;
  tone?: CheckoutInfoMessageTone;
  className?: string;
  textClassName?: string;
}
